import { App03Task, IEntity } from '../types';
import { EntityService } from './EntityService';

export class EmailNotificationsService extends EntityService<IEntity> {
    private zedxApiURL: string = process.env.REACT_APP_ZedX_Non_Odata_API!;

    constructor() {
        super(`/EmailNotifications`);
    }

    // public async sendEmailOnNewWorkflowTask(taskID: number): Promise<App03Task> {
    //     const endPoint: string = `${this.zedxApiURL}/EmailNotifications/SendEmailOnNewWorkflowTask?taskID=${taskID}`;
    //     const result = await super.readAnyEndPointValue(endPoint);
    //     return null;
    // }

    // public async sendEmailOnEditWorkflowTask(taskID: number): Promise<App03Task> {
    //     const endPoint: string = `${this.zedxApiURL}/EmailNotifications/SendEmailOnEditWorkflowTask?taskID=${taskID}`;
    //     const result = await super.readAnyEndPointValue(endPoint);
    //     return null;
    // }

}
